import { DriverSelector } from "modules/drivers";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { DriverBlockProps, FilterFormValues } from "../OrdersFilterForm.types";

import styles from "../OrdersFilterForm.module.scss";

export const DriverBlock = ({
  drivers: _drivers,
  isDriversLoading: _isDriversLoading
}: DriverBlockProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<FilterFormValues>();

  return (
    <div className={styles.orderFilterForm__block}>
      <h4 className={styles.orderFilterForm__block__title}>{t("Driver")}</h4>

      <div className={styles.orderFilterForm__block__box}>
        <Controller
          control={control}
          name="driverId"
          render={({ field: { value, onChange } }) => (
            <DriverSelector
              value={value}
              onChange={onChange}
              additionalOptions={[{ value: "", label: t("All") }]}
            />
          )}
        />
      </div>
    </div>
  );
};
